/**
 * Created by afuhr on 11.03.2017.
 */

export const LOGIN_TO_TOUCH_CLIENT = 'login touch-client';
export const LOGIN_TO_CLIENT = 'login client';
export const ACCESS_MOBILE_SCANNER = 'access mobile scanner';
export const HIDE_KEYBOARD = 'hide keyboard'



// WEBPACK FOOTER //
// ./src/app/shared/auth/guards/api-permission.ts